/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 麻痺(部位)
 */
export type FindEmsContactParalysisPartsEnum =
  (typeof FindEmsContactParalysisPartsEnum)[keyof typeof FindEmsContactParalysisPartsEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactParalysisPartsEnum = {
  WHOLE_BODY: 'WHOLE_BODY',
  RIGHT_SIDE: 'RIGHT_SIDE',
  LEFT_SIDE: 'LEFT_SIDE',
  UPPER_BODY: 'UPPER_BODY',
  LOWER_BODY: 'LOWER_BODY',
  RIGHT_UPPER_LIMB: 'RIGHT_UPPER_LIMB',
  LEFT_UPPER_LIMB: 'LEFT_UPPER_LIMB',
  RIGHT_LOWER_LIMB: 'RIGHT_LOWER_LIMB',
  LEFT_LOWER_LIMB: 'LEFT_LOWER_LIMB',
} as const;
